module.exports = __webpack_public_path__ + "img/finance.0b1ec36.png";